import { render } from "./BillingAndPaymentInvoices.vue?vue&type=template&id=4e4192e0&scoped=true"
import script from "./BillingAndPaymentInvoices.vue?vue&type=script&lang=js"
export * from "./BillingAndPaymentInvoices.vue?vue&type=script&lang=js"

import "./BillingAndPaymentInvoices.vue?vue&type=style&index=0&id=4e4192e0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4e4192e0"

export default script